import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import Widget from '~/src/components/Widget';
import { IServiceWidget } from '~/src/features/domru-tv/packages/sections/services/services';

import * as ST from './styled';

const ServiceCard = ({ service }: { service: IServiceWidget }): JSX.Element => {
    const { title, info = '', capabilities, price, link } = service;

    return (
        <Widget>
            <ST.WidgetContent>
                <ST.WidgetName>{title}</ST.WidgetName>
                {info && (
                    <ST.WidgetInfo data-test='service-info'>{info}</ST.WidgetInfo>
                )}
                <ul>
                    {capabilities.map(capability => (
                        <ST.CapabilityItem key={capability.id}>
                            <ST.CapabilityIcon src={capability.icon} alt={capability.info}/>
                            {capability.info}
                        </ST.CapabilityItem>
                    ))}
                </ul>
                <Widget.FooterBlock>
                    <Widget.Price>{price}</Widget.Price>
                    <BaseButton
                        type={btnTypes.PRIMARY}
                        size={btnSizes.SMALL}
                        text={'Подробнее'}
                        href={link}
                    />
                </Widget.FooterBlock>
            </ST.WidgetContent>
        </Widget>
    );
};

export default ServiceCard;
